goog.provide("shadow.js.shim.module$$mui$material$Fab");
goog.provide("module$shadow_js_shim_module$$mui$material$Fab");
shadow.js.shim.module$$mui$material$Fab = shadow.js.nativeProvides["@mui/material/Fab"] = shadow$bridge("@mui/material/Fab");
module$shadow_js_shim_module$$mui$material$Fab.default = shadow.js.shim.module$$mui$material$Fab;
